import { ValueLegend } from "src/components/ValueLegend/ValueLegend";
import { useMonthlyPnl } from "./hooks/useMonthlyPnl";
import { FadeLoading } from "src/components/FadeLoading/FadeLoading";
import { TimeSeriesStackedChart } from "@iliotech/widgets";
import React from "react";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import { useStructureGrouping } from "@iliotech/data-wire";

export const MonthlyPnl = ({
  height,
  width,
  isHalfHeight,
  structureContext,
  periodContext,
}: ReportWidgetProps) => {
  const { grouping, selectedGroup } =
    structureContext || useStructureGrouping();
  const { currencyFormatter, isLoading, legend, data } = useMonthlyPnl({
    overriddenGrouping: grouping,
    overriddenSelectedGroup: selectedGroup,
    overriddenPeriod: periodContext.period,
  });
  const byAllocationChart = React.useMemo(() => {
    return (
      <FadeLoading loading={isLoading}>
        <TimeSeriesStackedChart
          height={height}
          width={width}
          axisCrossingValue={100}
          valueAxisFormatter={currencyFormatter}
          items={data}
        />
      </FadeLoading>
    );
  }, [isLoading, currencyFormatter, data, height, width]);

  return (
    <div>
      <h4 className={"element-title"}>Monthly P&L</h4>
      <p className={"period-string"}>{periodContext.periodString}</p>
      {byAllocationChart}
      <ValueLegend small={isHalfHeight} items={legend} />
    </div>
  );
};
